export const RawJobIcon: React.FC<{ size?: number }> = ({ size = 15 }) => {
  return (
    <svg width={size} height={size} viewBox="0 0 10 10" fill="none">
      <circle
        cx="4.79663"
        cy="5.45312"
        r="3.75"
        fill="#00ADC7"
        stroke="white"
        strokeWidth="1.5"
      />
    </svg>
  );
};
